import {PollRobotTemplate} from './PollRobotTemplate.js';

export class PollRobotLogin {
	constructor(resolve,reject) {
		this.resolve = resolve;
		this.reject = reject;
		[this.el, this.$] = PollRobotTemplate(`PollRobotLogin`);
		//this.shadow = this.
		document.head.appendChild(this.$.style);
		document.body.appendChild(this.el);

		this.$.login.addEventListener(`click`, this.tryLogin.bind(this) );
		this.$.password.addEventListener(`keypress`, this.checkEnter.bind(this) );
	}

	checkEnter(evt){
		if(evt.keyCode == 13){
			this.tryLogin(evt);
		}
	}
	tryLogin(evt) {
		evt.preventDefault(); evt.stopPropagation();
		// console.log(`username = ${this.$.username.value}, password = ${this.$.password.value}`);
		fetch(`/login`, {
			method: `POST`,
			body: JSON.stringify({
				login: this.$.username.value,
				password: this.$.password.value
			})
		}).then( res=>res.json() )
		.then(
			js=>{
				if (`ok`==js.Status) {
					sessionStorage.setItem(`pollrobot-token`, js.Token);
					this.resolve(js.Token);
					this.el.remove();
				} else {
					console.log(`LOGIN failed: `, js.Error)
					alert(js.Error);
				}
			})
		.catch(err => {
			console.log(err);
			alert(`That didn't work. Try again?`)
		});
	}
	static tryWithToken() {
		let token = sessionStorage.getItem(`pollrobot-token`);
		if (token) {
			return fetch(`/login/token/${encodeURIComponent(token)}`).then(
				res=>res.json() ).then(
				js=>{
					if (js.ok) {
						return token;
					}
					return false;
				});
		}
		return Promise.resolve(false);
	}
	
	static Login() {
		return PollRobotLogin.tryWithToken().then( tok=>{
			if (tok) return tok;
			return new Promise((resolve,reject)=>{
				new PollRobotLogin(resolve, reject);
			});
		});
	}
	userLoggedInSuccess(tok) {
		this.resolve(tok);
	}
}